import {createUploadLink} from 'apollo-upload-client';

// instead of createHttpLink, use createUploadLink due to apollo-upload-client
const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_GRAPH_URL,
});

export default uploadLink;
